'use strict';

var sleeknote = sleeknote || {};

sleeknote.codeSnippet = sleeknote.codeSnippet || function () {

    
    function init() {

        $(document).ready(function(){
        
            $("pre").html(function (index, html) {
                return html.replace(/^(.*)$/mg, "<span class=\"line\">$1</span>")
            });

        });

    }


    return {
        init:init
    };


}();